import { pushEvent } from 'src/client/data-layer';

// Opened
export const trackProductMediaOpened = () => pushEvent('productMediaOpened');

type MediaViewedArgs = {
  index: number;
};

// Viewed image with index
export const trackProductMediaViewed = ({ index }: MediaViewedArgs) =>
  pushEvent('productMediaViewed', { index });
